module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/modules/_redefine.js
// module id = 780
// module chunks = 2